export const GET_PENDING_APPLICATIONS = 'GET_PENDING_APPLICATIONS';
export const GET_PENDING_APPLICATIONS_SUCCESS = 'GET_PENDING_APPLICATIONS_SUCCESS';
export const GET_PENDING_APPLICATIONS_ERROR = 'GET_PENDING_APPLICATIONS_ERROR';

export const APPROVE_PERMIT_APPLICATION = 'APPROVE_PERMIT_APPLICATION';
export const APPROVE_PERMIT_APPLICATION_SUCCESS = 'APPROVE_PERMIT_APPLICATION_SUCCESS';
export const APPROVE_PERMIT_APPLICATION_ERROR = 'APPROVE_PERMIT_APPLICATION_ERROR';
export const APPROVE_APPLICATION_CAPACITY_ERROR = 'APPROVE_APPLICATION_CAPACITY_ERROR';
export const CLEAR_CAPACITY_ERROR = 'CLEAR_CAPACITY_ERROR';

export const DENY_PERMIT_APPLICATION = 'DENY_PERMIT_APPLICATION';
export const DENY_PERMIT_APPLICATION_SUCCESS = 'DENY_PERMIT_APPLICATION_SUCCESS';
export const DENY_PERMIT_APPLICATION_ERROR = 'DENY_PERMIT_APPLICATION_ERROR';

export const OVERRIDE_PARKING_CAPACITY = 'OVERRIDE_PARKING_CAPACITY';
export const OVERRIDE_PARKING_CAPACITY_SUCCESS = 'OVERRIDE_PARKING_CAPACITY_SUCCESS';
export const OVERRIDE_PARKING_CAPACITY_ERROR = 'OVERRIDE_PARKING_CAPACITY_ERROR';
